import React, { useEffect, useState, useRef } from 'react';
 import KeyRegCards_FPS from '../keyregister/KeyRegCards_FPS';
 import CircularProgress from '@mui/material/CircularProgress';
 import Box from '@mui/material/Box';

const KeyRegisterAllotAfso_data = async (params) => {
    const response = await fetch(`${process.env.REACT_APP_URL_ALLOTMENT}/KeyRegister/getafsoKeyRegisterCards`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const KeyRegCards_Afso = ({ month, year, dist_code }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContenttt, setRenderContenttt] = useState(null);
    const details2 = useRef(null); // Use ref to scroll to this div
    const [schemelist ,setschemelist] = useState([]);
    const [nfsaSchemeList, setNfsaSchemeList] = useState([]);
    const [stateSchemeList, setStateSchemeList] = useState([]);
          //  const [renderContentt, setRenderContentt] = useState(null);
     const detailsRRef = useRef(null);

    const handleAfsoClick = (month, year, dist_code, afso_code) => {

        setTimeout(() => {
            setRenderContenttt(null);

            setRenderContenttt(
                <KeyRegCards_FPS
                    month={month}
                    year={year}
                    dist_code={dist_code}
                    afso_code={afso_code}
                />
            );

        }, 10);
    };


    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await KeyRegisterAllotAfso_data({ month, year,dist_code });
                setTabHeading(response_data.heading);

                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);


                    console.log(response_data.date +">>>>response_data" );
                    // Flatten NFSA and Non-NFSA schemes
                    const nfsa = [];
                    const state = [];
                    response_data.data.forEach(item => {
                        item.schemeWrapperList .forEach(scheme => {
                            if (scheme.nfsaSchemeList) nfsa.push(...scheme.nfsaSchemeList);
                            if (scheme.stateSchemeList) state.push(...scheme.stateSchemeList);
                        });
                    });

                    // Remove duplicates based on scheme_id
                    const uniqueNfsa = Array.from(new Map(nfsa.map(s => [s.scheme_id, s])).values());
                    const uniqueState = Array.from(new Map(state.map(s => [s.scheme_id, s])).values());

                    setNfsaSchemeList(uniqueNfsa);
                    setStateSchemeList(uniqueState);
                } else {
                    setReportData([]);
                    setNfsaSchemeList([]);
                    setStateSchemeList([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year,dist_code]);


   useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [loading, error, reportData]);

    if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}><CircularProgress /></Box></div>;
    if (error) return <div className="mainhead" align="center">Internal Error</div>;
    if (!reportData || reportData.length === 0) return <div className="mainhead" align="center">No data found</div>;

    const allSchemes = [...nfsaSchemeList, ...stateSchemeList];

    const totals = {
        total_shops: 0,
        total_cards: 0,
        total_units: 0,
        schemes: {}
    };

    // Initialize totals for each scheme
    allSchemes.forEach(s => {
        totals.schemes[s.scheme_id] = { cards: 0, units: 0 };
    });

    // Compute totals
    reportData.forEach(item => {
        totals.total_shops += item.total_shops || 0;
        totals.total_cards += item.total_cards || 0;
        totals.total_units += item.total_units || 0;

        allSchemes.forEach(scheme => {
            let data;
            item.schemeWrapperList.forEach(s => {
                data = s.nfsaSchemeList?.find(n => n.scheme_id === scheme.scheme_id) || data;
                data = s.stateSchemeList?.find(n => n.scheme_id === scheme.scheme_id) || data;
            });
            totals.schemes[scheme.scheme_id].cards += data?.cards || 0;
            totals.schemes[scheme.scheme_id].units += data?.units || 0;
        });
    });

    return (
        <>
            <table id="myTable" align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={allSchemes.length * 2 + 5}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>Office</th>
                        <th rowSpan={3}>Total <br /> FPS</th>
                        <th rowSpan={3}>Total <br /> Cards</th>
                        <th rowSpan={3}>Total <br /> Units</th>
                        {nfsaSchemeList?.length > 0 && (
                            <th colSpan={nfsaSchemeList.length * 2}>NFSA</th>
                        )}

                        {stateSchemeList?.length > 0 && (
                            <th colSpan={stateSchemeList.length * 2}>Non-NFSA</th>
                        )}
                    </tr>
                    <tr className="tableheader">
                        {nfsaSchemeList.map((s, i) => <th colSpan={2} key={i}>{s.scheme_short_name}</th>)}
                        {stateSchemeList.map((s, i) => <th colSpan={2} key={'s' + i}>{s.scheme_short_name}</th>)}
                    </tr>
                    <tr className="tableheader">
                        {allSchemes.map((s, i) => (
                            <React.Fragment key={i}>
                                <th>Cards</th>
                                <th>Units</th>
                            </React.Fragment>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.dist_Code}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                                <a style={{ cursor: 'pointer', color: 'blue' }}
                                    onClick={() => handleAfsoClick(month, year,item.dist_Code,item.afso_code)}>
                                    {item.afso_name_en}
                                </a>
                            </td>
                            <td style={{ textAlign: 'right' }}>{item.total_shops}</td>
                            <td style={{ textAlign: 'right' }}>{item.total_cards}</td>
                            <td style={{ textAlign: 'right' }}>{item.total_units}</td>

                            {allSchemes.map((scheme, i) => {
                                let data;
                                // Check nfsa and State separately
                                item.schemeWrapperList .forEach(s => {
                                    data = s.nfsaSchemeList?.find(n => n.scheme_id === scheme.scheme_id) || data;
                                    data = s.stateSchemeList?.find(n => n.scheme_id === scheme.scheme_id) || data;
                                });
                                return (
                                    <React.Fragment key={i}>
                                        <td style={{ textAlign: 'right' }}>{data?.cards || 0}</td>
                                        <td style={{ textAlign: 'right' }}>{data?.units || 0}</td>
                                    </React.Fragment>
                                );
                            })}
                        </tr>
                    ))}


                    <tr className="tableheader">
                        <td colSpan={2} style={{ textAlign: 'center' }}>Total</td>
                        <td style={{ textAlign: 'right' }}>{totals.total_shops}</td>
                        <td style={{ textAlign: 'right' }}>{totals.total_cards}</td>
                        <td style={{ textAlign: 'right' }}>{totals.total_units}</td>
                        {allSchemes.map((scheme, i) => (
                            <React.Fragment key={i}>
                                <td style={{ textAlign: 'right' }}>{totals.schemes[scheme.scheme_id].cards}</td>
                                <td style={{ textAlign: 'right' }}>{totals.schemes[scheme.scheme_id].units}</td>
                            </React.Fragment>
                        ))}
                    </tr>


                    <tr className="tableheader">
                        <th colSpan={allSchemes.length * 2 + 5} style={{ textAlign: 'right' }}>
                            Data Time: {reportData[0].update_time.substring(0, 16)}
                        </th>
                    </tr>
                </tbody>
            </table>

            <br /><br />
            <br></br>
            <div id="detailsERR" ref={detailsRRef}>{renderContenttt}</div>
        </>
    );
};

export default KeyRegCards_Afso;

